/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CreateRestrictionCheckRequestDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const CreateRestrictionCheckRequestDTOMarketplacesEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the CreateRestrictionCheckRequestDTO interface.
 */
export function instanceOfCreateRestrictionCheckRequestDTO(value) {
    return true;
}
export function CreateRestrictionCheckRequestDTOFromJSON(json) {
    return CreateRestrictionCheckRequestDTOFromJSONTyped(json, false);
}
export function CreateRestrictionCheckRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'marketplaces': json['marketplaces'] == null ? undefined : json['marketplaces'],
        'asinList': json['asinList'] == null ? undefined : json['asinList'],
        'autoSearch': json['autoSearch'] == null ? undefined : json['autoSearch'],
        'skuSegment': json['skuSegment'] == null ? undefined : json['skuSegment'],
    };
}
export function CreateRestrictionCheckRequestDTOToJSON(json) {
    return CreateRestrictionCheckRequestDTOToJSONTyped(json, false);
}
export function CreateRestrictionCheckRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'marketplace': value['marketplace'],
        'marketplaces': value['marketplaces'],
        'asinList': value['asinList'],
        'autoSearch': value['autoSearch'],
        'skuSegment': value['skuSegment'],
    };
}
